import useApi from "hooks/useApi";
import { useQuery } from "react-query";
import { handleAxiosError } from "./utils";

export interface GetReportResponse {
  key: string;
  headers: string[];
  rows: string[][];
}

const GET_REPORT_ENDPOINT = "/get-report";

export default function useQueryGetReport(key: string) {
  const api = useApi();

  const fetchGetReport: () => Promise<GetReportResponse> = async () => {
    try {
      const { data } = await api.get<GetReportResponse>(GET_REPORT_ENDPOINT, {
        params: { key },
      });
      return data;
    } catch (e) {
      return handleAxiosError(e);
    }
  };

  return useQuery<GetReportResponse, string>(["getReport", key], fetchGetReport, {
    enabled: !!key,
  });
}
